<template>
    <div class="el-tree" :class="{ 'el-tree-highlight-current': highlightCurrent }">
        <i-tree-node
                v-for="child in root.childNodes"
                :node="child"
                :props="props"
                :key="getNodeKey(child)"
                :render-content="renderContent">
        </i-tree-node>
        <div class="el-tree-empty-block" v-if="!root.childNodes || root.childNodes.length === 0">
            <span class="el-tree-empty-text">{{ emptyText }}</span>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import TreeStore from './model/tree-store';
    import TreeNode from './tree-node';
    import { $t } from '../../../utils/locale';

    export default {
        name: 'el-tree',

        props: {
            data: {
                type: Array
            },
            emptyText:{
                type:String,
                default(){
                    return $t('el.tree.emptyText')
                }
            },
            nodeKey:String,
            checkStrictly:Boolean,
            defaultExpandAll:Boolean,
            autoExpandParent:{
                type:Boolean,
                default:true
            },
            defaultCheckedKeys:Array,
            defaultExpandedKeys:Array,
            renderContent: Function,
            showCheckbox: {
                type: Boolean,
                default: false
            },
            props: {
                default() {
                    return {
                        children: 'children',
                        label: 'label',
                        icon: 'icon'
                    };
                }
            },
            lazy: {
                type: Boolean,
                default: false
            },
            highlightCurrent: Boolean,
            load: {
                type: Function
            },
            filterNodeMethod:Function
        },

        created() {
            this.isTree = true;

            this.store = new TreeStore({
                key: this.nodeKey,
                data: this.data,
                lazy: this.lazy,
                props: this.props,
                load: this.load,
                checkStrictly:this.checkStrictly,
                defaultCheckedKeys:this.defaultCheckedKeys,
                defaultExpandedKeys:this.defaultExpandedKeys,
                autoExpandParent:this.autoExpandParent,
                defaultExpandAll:this.defaultExpandAll,
                filterNodeMethod:this.filterNodeMethod
            });

            this.root = this.store.root;
        },

        data() {
            return {
                store: null,
                root:null,
                currentNode: null
            };
        },

        components: {
            'i-tree-node': TreeNode
        },

        computed: {
            children: {
                set(value) {
                    this.data = value;
                },
                get() {
                    return this.data;
                }
            }
        },

        watch: {
            data(newVal) {
                this.store.setData(newVal);
            },
            defaultCheckedKeys(newVal){
                this.store.defaultCheckedKeys = newVal;
                this.store.setDefaultCheckedKey(newVal);
            },
            defaultExpandedKeys(newVal){
                this.store.defaultExpandedKeys = newVal;
                this.store.setDefaultExpandedKeys(newVal);
            }
        },

        methods: {
            filter(value){
                if(!this.filterNodeMethod){
                    throw new Error('[Tree] filterNodeMethod is required when filter');
                }
                this.store.filter(value);
            },
            getNodeKey(node,index){
                const nodeKey = this.nodeKey;
                if(nodeKey && node){
                    return node.data[nodeKey];
                }
                return index;
            },
            getCheckedNodes(leafOnly){
                return this.store.getCheckedNodes(leafOnly);
            },
            getCheckedKeys(leafOnly){
                return this.store.getCheckedKeys(leafOnly);
            },
            setCheckedNodes(nodes,leafOnly){
                if(!this.nodeKey){
                    throw new Error('[Tree] nodeKey is required in setCheckedNodes');
                }
                this.store.setCheckedNodes(keys,leafOnly);
            },
            setCheckedKeys(keys,leafOnly){
                if(!this.nodeKey){
                    throw new Error('[Tree] nodeKey is required in setCheckedNodes');
                }
                this.store.setCheckedKeys(keys,leafOnly);
            },
            setChecked(data,checked,deep){
                this.store.setChecked(data,checked,deep);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/tree/src/tree.vue